"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var styleOverrides = {
    root: function(param) {
        var theme = param.theme;
        return {
            fontSize: '1.2rem',
            color: theme.palette.grey[500],
            justifyContent: 'center'
        };
    },
    selectLabel: {
        fontSize: '1.2rem'
    },
    displayedRows: {
        fontSize: '1.2rem'
    },
    actions: {
        display: 'inline-flex',
        gap: 15
    }
};
var defaultProps = {
};
var _default = exports.default = {
    styleOverrides: styleOverrides,
    defaultProps: defaultProps
}; //# sourceMappingURL=MuiTablePagination.js.map
